<template>
  <v-card max-width="1200px" outlined>
    <v-card-title class="py-0">
      {{ $t('ELE0177') }}
    </v-card-title>
    <v-card-text>
      <v-card outlined>
        <v-simple-table class="header-gray" dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left v-data-table__divider" width="20%">{{ $t('ELE0042') }}</th>
                <th class="text-left v-data-table__divider" width="30%">{{ $t('ELE0190') }}</th>
                <th class="text-left v-data-table__divider" width="20%">{{ $t('ELE0042') }}</th>
                <th class="text-left">{{ $t('ELE0190') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in infoList" :key="item.info1.name">
                <td class="v-data-table__divider">{{ item.info1.name }}</td>
                <td :class="[item.info1.class, 'text-left v-data-table__divider']">
                  {{ item.info1.value }}
                </td>
                <td class="v-data-table__divider">{{ item.info2.name }}</td>
                <td v-if="item.info2.isSa && item.info2.value != ''" :class="item.info2.class">
                  <BtnLink :label="item.info2.value" @click="onClickSaNo" />
                </td>
                <td v-else :class="item.info2.class">{{ item.info2.value }}</td>
              </tr>
              <tr>
                <td class="v-data-table__divider">{{ $t('ELE0054') }}</td>
                <td
                  colspan="3"
                  class="v-data-table__divider"
                  style="word-break: break-all; word-wrap: break-all; white-space: pre-line !important"
                >
                  {{ indexDetail.remarks }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import DateUtil from '@/mixin/date-utils.js'
import Loading from '@/mixin/loading-utils.js'
import BtnLink from '@/components/atoms/base/button/BtnLink'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import { InspResultCd, ModelPlantJudgeCd } from '@/enum'
import { API } from '@/plugins/api'
import StringUtils from '@/mixin/string-utils.js'

export default {
  name: 'InspIndexDetail',

  mixins: [DateUtil, Loading, StringUtils],

  components: {
    BtnLink,
    TextFieldRef,
  },

  props: {
    indexDetail: {
      type: Object,
      required: true,
    },
    inspClassCd: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      infoList: [],
    }
  },

  computed: {
    saNoList: {
      get() {
        let array = []
        if (this.indexDetail && this.indexDetail.saNoList) {
          array = this.indexDetail.saNoList
        }
        return array
      },
    },
    saNoLink: {
      get() {
        let value = ''
        if (this.saNoList.length >= 2) {
          value += this.saNoList[0] + ', ' + this.saNoList[1]

          if (this.saNoList.length > 2) {
            value += ' ･･･'
          }
        } else if (this.saNoList.length == 1) {
          value += this.saNoList[0]
        }

        return value
      },
    },
  },

  watch: {
    indexDetail: {
      handler(value) {
        this.setIndexDetail(value)
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async setIndexDetail(indexDetail) {
      const sameLot = this.setSameLotData()
      const modelPlantJudgeResult = await this.getSaModelPlantJudge()
      let info1 = []
      info1.push({ name: this.$t('ELE0137'), value: indexDetail.inspIndexNo })
      info1.push({ name: this.$t('ELE0140'), value: this.$t('InspTiming.' + indexDetail.inspTimingCd), class: '' })
      info1.push({ name: this.$t('ELE0048'), value: indexDetail.inspCompanyName, class: '' })
      info1.push({ name: this.$t('ELE0057'), value: indexDetail.manufacturerName, class: '' })
      info1.push({ name: this.$t('ELE0049'), value: indexDetail.lotNo, class: '' })
      info1.push({ name: this.$t('ELE0153'), value: this.toLocalDate(indexDetail.lotDate) })
      info1.push({ name: this.$t('ELE0050'), value: indexDetail.lotQty, class: 'text-right' })
      info1.push({ name: this.$t('ELE0031'), value: indexDetail.partCd, class: '' })
      info1.push({ name: this.$t('ELE0032'), value: indexDetail.partName, class: '' })
      info1.push({ name: this.$t('ELE0347'), value: sameLot.value, class: sameLot.class })
      info1.push(this.getInspResultColmun(indexDetail.oqcInspResultCd, indexDetail.oqcIsOutCl))
      let info2 = []
      info2.push({ name: this.$t('ELE0052'), value: indexDetail.mmmmApplNo, class: '' })
      info2.push({ name: this.$t('ELE0053'), value: indexDetail.matlSpec, class: '' })
      info2.push({
        name: this.appendFilteringInspTimingCd(this.$t('ELE0143'), indexDetail),
        value: indexDetail.inspFilteringName,
        class: '',
      })
      info2.push({ name: this.$t('ELE0144'), value: indexDetail.inspBasicQty, class: 'text-right' })
      info2.push({
        name: this.appendFilteringInspTimingCd(this.$t('ELE0145'), indexDetail),
        value: indexDetail.aqlRateName,
        class: '',
      })
      info2.push({ name: this.$t('ELE0178'), value: this.saNoLink, class: '', isSa: true })
      info2.push({
        name: this.$t('ELE0356'),
        value: modelPlantJudgeResult.value,
        class: modelPlantJudgeResult.class,
      })
      info2.push({ name: this.$t('ELE0346'), value: indexDetail.aqlDetermQty, class: 'text-right' })
      info2.push({ name: this.$t('ELE0171'), value: indexDetail.aqlSamplingSize, class: 'text-right' })
      info2.push({ name: this.$t('ELE0172'), value: indexDetail.acQty, class: 'text-right' })
      info2.push({ name: this.$t('ELE0173'), value: indexDetail.reQty, class: 'text-right' })
      let infoList = []
      for (let i = 0; i <= info1.length - 1; i++) {
        infoList.push({ info1: info1[i], info2: info2[i] })
      }
      this.infoList = infoList
    },
    onClickSaNo() {
      if (this.saNoList.length == 1) {
        const resolvedRoute = this.$router.resolve({
          name: 'T07',
          query: { saNo: this.saNoList[0] },
        })
        window.open(resolvedRoute.href, '_blank')
      } else {
        const resolvedRoute = this.$router.resolve({
          name: 'T06',
          query: { partCd: this.indexDetail.partCd, inspClassCd: this.inspClassCd },
        })
        window.open(resolvedRoute.href, '_blank')
      }
    },
    getInspResultColmun(oqcInspResultCd, oqcIsOutCl) {
      let result = { name: this.$t('ELE0350'), value: '', class: '' }
      if (oqcInspResultCd != null) {
        result.value = this.getInspResultName('InspResultCd.', oqcInspResultCd, oqcIsOutCl)
      }
      return result
    },
    appendFilteringInspTimingCd(label, indexDetail) {
      if (indexDetail.filteringInspTimingCd) {
        label = label + ' (' + this.$t(`InspTiming.${indexDetail.filteringInspTimingCd}`) + ')'
      }
      return label
    },
    setSameLotData() {
      let result = {
        class: '',
        value: '',
      }
      if (this.indexDetail.canSkipDimInsp) {
        if (this.indexDetail.latestDimInspResult === null) {
          result.class = 'does-not-exists-cell'
          result.value = this.$t('ELE0349')
        } else {
          result.value = this.$t(`InspResultCd.${this.indexDetail.latestDimInspResult}`)
          if (this.indexDetail.latestDimInspResult == InspResultCd.NG) {
            result.class = 'does-not-exists-cell'
          } else {
            result.class = 'exists-cell'
          }
        }
      }
      return result
    },
    async getSaModelPlantJudge() {
      let result = {
        class: '',
        value: '',
      }
      try {
        const params = {
          saNos: this.saNoList,
          judge: ModelPlantJudgeCd.NG,
        }
        const elements = await API.get('/sa/modelPlants', params)
        if (elements.length > 0) {
          result.value = this.$t('MSG0129')
          result.class = 'does-not-exists-cell'
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0224') })))
      }
      return result
    },
  },
}
</script>
<style scoped>
.exists-cell {
  background-color: #edeffd !important;
}
.does-not-exists-cell {
  background-color: #f8ced2 !important;
}
</style>
